<template>
    <div class="imgupload" v-loading="fullscreenLoading">
        <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline" size="mini" ref="sendDataInfo"
            :show-message="false">
            <el-form-item label="选择银行" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                <el-select v-model="sendDataInfo.readId" placeholder="请选择">
                    <el-option v-for="item in bankList" :key="item.readId" :label="item.bankName" :value="item.readId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="账簿" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                <label slot="label" :style="$common.labelStyle('账簿')" v-html="'账簿'"></label>
                        <el-input clearable v-model="sendDataInfo.abookName"  class="form_codition"
                            @keyup.enter.native="openSearch('336844454858752', 0, 'abookName','abookId,abookName')">
                            <el-button @click="openSearch('336844454858752', 0, 'abookName','abookId,abookName')"
                                slot="append" icon="el-icon-search"></el-button>
                        </el-input>
            </el-form-item>
            <el-form-item>
                <el-upload class="upload-demo" ref="upload" :action="requesUrl + 'runwater/upload'" :limit="limit"
                    name="file" :headers="header" :on-preview="handlePreview" :file-list="fileList"
                    :on-error="uploadFalse" :on-success="uploadSuccess" :auto-upload="true" :on-remove="onRemove"
                    :before-upload="beforeAvatarUpload" :http-request="handleUploadForm">
                    <el-button slot="trigger" size="small" type="primary">选取excel文件</el-button>
                    <el-button style="margin-left: 10px;" size="small" type="success"
                        @click="submitUpload()">提交上传</el-button>
                    <!-- <div slot="tip" class="el-upload__tip">只能上传excel文件</div> -->
                </el-upload>
            </el-form-item>

        </el-form>

        <div style="padding:20px; height: 500px">
            <el-table v-if="tableHeadArr.length" :data="tableData" style="width: 100%" height="420px"
                :row-style="rowStyle" border>
                <el-table-column v-for="(item, key) in tableHeadArr" :label="item.showField" :key="key" width="180">
                    <template slot-scope="scope">
                        <!-- 开票日期 -->
                        <template v-if="item.entityField == 'backDate'">
                            <span v-if="scope.row[item.entityField]">
                                {{ $common.getLocalTime(scope.row[item.entityField],true) }}
                            </span>
                        </template>

                        <el-tag v-else-if="item.entityField == 'abnormalFlag'" size="mini">
                            {{ scope.row[item.entityField] == 1 ? "未匹配到客户" : "读取成功" }}
                        
                        </el-tag>
                        <span v-else>{{ scope.row[item.entityField] }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :title="seTitle" :append-to-body="true" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData"
                @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'customUpload',
    data() {
        return {
            DialogVisible: false,
            file: "",
            tableData: [],
            sendDataInfo: {
                readId: "",
                abookName:"",
                abookId:""
            },
            searchStatus: false,
            searchType: '',
            setField: '',
            nowField: "",
            fullscreenLoading: false,
            fileList: [],
            seWidth: '0',
            seId: 0,
            smId: 0,
            sField: '',
            requesUrl: '',
            otherData: {
                state: 0
            },
            parentSearchData:{},
            seTitle:""


        };
    },
    props: {
        header: {
            type: Object,
            default: () => {
                return {
                    'Content-Type': 'multipart/form-data',
                    token: sessionStorage.getItem('token')
                }
            },
        },
        // 最大上传数量
        limit: {
            type: [Number, String],
            default: () => 1,
        },
        bankList: {
            type: Array,
            require: true,
            default: () => { return [] },
        },
        tableHeadArr: {
            type: Array,
            require: true,
            default: () => { return [] },
        },
    },
    created() {
        this.requesUrl = this.$store.getters.getConfig.requestUrl;
    },
    methods: {
        getSeWidth(e) {
                // console.log(e);
                this.seWidth = e + "%";
            },
            getWidth(e) {
                // console.log(e);
                this.exWidth = e + "%";
            },
            getSearchName(e) {
                // console.log(e);
                this.seTitle = e;
            },
            //检索带回数据
            changeInputModel(val) {
                if (val != "" || val != undefined) {
                    this.DialogVisible = false;
                    if (this.seType == 'smName') this.parentSearchData.smId = val.smId
                    this.paramValue(val)
                }
            },
            // 赋值字段
            paramValue(val) {
                let arr = this.sField.split(',')
                arr.forEach(item => {
                    this.sendDataInfo[item] = val[item]
                })
            },
            // 检索Id, 索引(表格中), 标识
            openSearch(sId, index, type, sField) {
                if (type == 'salesName' && this.sendDataInfo.smId == '') {
                    return this.$message({
                        message: '请先选择购进单位',
                        type: "warning",
                    });
                }
                this.DialogVisible = true
                this.seType = type
                this.seId = sId
                this.sField = sField
                this.parentSearchData[type] = this.sendDataInfo[type]
            },
        rowStyle(row) {
            console.log(row)
            if (row.row.abnormalFlag === 1) {
                return { 'background-color': '#F56C6C' };
            }
        },
        beforeAvatarUpload(file) {
            console.log(file)
            if (this.sendDataInfo.readId == "") {
                this.$message({
                    type: 'error',
                    message: '请先选择银行!',
                })
                return false
            }
            var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
            const extension = testmsg === 'xls'
            // const extension2 = testmsg === 'xlsx'
            const isLt2M = file.size / 1024 / 1024 < 10
            if (!extension ) {
                this.$message({
                    message: '上传文件只能是 xls格式!',
                    type: 'warning'
                });
            }

            return extension || extension2 //&& isLt2M
        },
        onRemove() {
            this.tableData = []
        },
        handleUploadForm(param) {


            let formData = new FormData()

            // 在formData中加入我们需要的参数
            formData.append('file', param.file)
            formData.append('readId', this.sendDataInfo.readId)
            formData.append('abookId', this.sendDataInfo.abookId)
            console.log('handleUploadForm', param, formData);
            // 向后端发送数据
            this.$http.runwaterImportWater(formData).then((res) => {
                if (res.status === 200) {
                    this.tableData = res.result
                    this.$message.success('上传成功')
                    // this.$emit('closeExcel', true)
                } else {
                    this.$message.error(res.message)
                    upload.value.clearFiles()
                }
            })
        },



        uploadSuccess(response, file, fileList) {
            console.log(response);
            if (response.status == 0) {
                console.log("文件导入成功");
            } else {
                console.log("文件导入失败");
            }
        },
        uploadFalse(response, file, fileList) {
            alert("文件上传失败！");
        },


        // 触发组件的提交
        submitUpload() {
            // this.$refs.upload.submit();
            console.log(JSON.parse(JSON.stringify(this.fileList)));
            this.$http.runwaterSubmitReadWater({ list: this.tableData }).then(res => {
                this.$message.success(res.message)
                    this.$emit('closeExcel', true)
            })

        },

        handlePreview(file) {
            console.log(file);
            if (file.status) {
                alert("此文件导入成功");
            } else {
                alert("此文件导入失败");
            }
        },
    },
};
</script>
<style scoped></style>